import * as React from "react"

const SvgComponent = (props) => (
  <svg
    width={18}
    height={19}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 .5c-4.967 0-9 4.033-9 9s4.033 9 9 9 9-4.033 9-9-4.033-9-9-9Zm0 .783A8.222 8.222 0 0 1 17.218 9.5 8.222 8.222 0 0 1 9 17.718 8.222 8.222 0 0 1 .783 9.5 8.222 8.222 0 0 1 9 1.283Z"
      fill="#000"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 4.414a2.74 2.74 0 0 0-2.74 2.74A2.74 2.74 0 0 0 9 9.891a2.74 2.74 0 0 0 2.739-2.739 2.74 2.74 0 0 0-2.74-2.739Zm0 .783A1.958 1.958 0 0 1 9 9.11a1.958 1.958 0 0 1 0-3.913Z"
      fill="#000"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.982 14.28a5.87 5.87 0 0 1 10.036 0 .391.391 0 1 0 .668-.406 6.65 6.65 0 0 0-11.372 0 .392.392 0 0 0 .668.406Z"
      fill="#000"
    />
  </svg>
)

export default SvgComponent